"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  hu: {
    shoppingLists: {
      actions: {
        insert: 'add a kosárhoz',
        rename: 'újra elnevezés'
      },
      shoppingListsDialog: {
        title: 'vásárlási listáim'
      },
      saveShoppingListDialog: {
        title: 'mentsd el a vásárlási listát névvel',
        shoppingListName: {
          label: 'lista neve',
          helperText: 'adj nevet a vásárlási listának.Ezzel a névvel a lista késõbb azonosítható.A név késõbb megváltozatható.',
          helperTextPreview: ''
        }
      },
      shoppingListItemCollapsed: {
        quantity: 'darab'
      }
    }
  }
};
var _default = messages;
exports.default = _default;